var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-notify-pill" },
    [
      _vm.showChanged ? [_c("span", [_vm._v("Uppdaterad!")])] : _vm._e(),
      _vm._v(" "),
      _vm.showUpdateCourse
        ? [_c("span", [_vm._v("Kurser måste uppdateras")])]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }